export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "order-form.worker.81e0f0ac8d486409.worker.js");
}
